export default "__VITE_ASSET__va48CiDz__"